module.exports = __webpack_public_path__ + "static/merchants-app-logo-20b85e6bae250c731601b94ef3858a96.png";